module.exports = __webpack_public_path__ + "img/management-function-2.2388841d.png";